import { Directive, ElementRef, HostListener, OnDestroy, Renderer2 } from '@angular/core';

@Directive({
  selector: 'ion-checkbox, input[type=checkbox], ng-select, [appKeyboardFocusVisible]'
})
export class KeyboardFocusVisibleDirective implements OnDestroy {
  private static isKeyboardNavigation = true;
  private isFocused = false;

  constructor(
    private readonly elementRef: ElementRef<HTMLElement>,
    private readonly renderer: Renderer2
  ) {}

  @HostListener('document:keydown', ['$event'])
  onGlobalKeydown(event: KeyboardEvent) {
    if (!['Tab', 'Enter', 'ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight'].includes(event.key)) {
      return;
    }

    KeyboardFocusVisibleDirective.isKeyboardNavigation = true;

    if (this.isFocused) {
      this.setFocusVisible(true);
    }
  }

  @HostListener('document:mousedown')
  @HostListener('document:touchstart')
  onGlobalPointerInteraction() {
    KeyboardFocusVisibleDirective.isKeyboardNavigation = false;

    if (this.isFocused) {
      this.setFocusVisible(false);
    }
  }

  @HostListener('ionFocus')
  onIonFocus() {
    this.isFocused = true;
    this.setFocusVisible(KeyboardFocusVisibleDirective.isKeyboardNavigation);
  }

  @HostListener('ionBlur')
  onIonBlur() {
    this.isFocused = false;
    this.setFocusVisible(false);
  }

  @HostListener('focusin')
  onFocusIn() {
    this.isFocused = true;
    this.setFocusVisible(KeyboardFocusVisibleDirective.isKeyboardNavigation);
  }

  @HostListener('focusout')
  onFocusOut() {
    this.isFocused = false;
    this.setFocusVisible(false);
  }

  ngOnDestroy() {
    this.toggleLegacyIonicCheckboxRing(false);
  }

  private setFocusVisible(shouldShow: boolean) {
    if (!this.isFocused && shouldShow) {
      return;
    }

    if (shouldShow) {
      this.renderer.addClass(this.elementRef.nativeElement, 'app-keyboard-focus-visible');
      this.toggleLegacyIonicCheckboxRing(true);
      return;
    }

    this.renderer.removeClass(this.elementRef.nativeElement, 'app-keyboard-focus-visible');
    this.toggleLegacyIonicCheckboxRing(false);
  }

  private toggleLegacyIonicCheckboxRing(shouldShow: boolean) {
    const host = this.elementRef.nativeElement;
    if (host.tagName?.toLowerCase() !== 'ion-checkbox') {
      return;
    }

    const shadowRoot = (host as HTMLElement).shadowRoot;
    if (!shadowRoot) {
      return;
    }

    const legacyCheckboxEl = shadowRoot.querySelector('.checkbox-icon, .native-wrapper') as HTMLElement | null;
    if (!legacyCheckboxEl) {
      return;
    }

    if (shouldShow) {
      this.renderer.setStyle(legacyCheckboxEl, 'outline', '2px solid #0c4da2');
      this.renderer.setStyle(legacyCheckboxEl, 'outline-offset', '2px');
      this.renderer.setStyle(legacyCheckboxEl, 'box-shadow', '0 0 0 3px rgba(12, 77, 162, 0.3)');
      this.renderer.setStyle(legacyCheckboxEl, 'border-radius', '4px');
      return;
    }

    this.renderer.removeStyle(legacyCheckboxEl, 'outline');
    this.renderer.removeStyle(legacyCheckboxEl, 'outline-offset');
    this.renderer.removeStyle(legacyCheckboxEl, 'box-shadow');
    this.renderer.removeStyle(legacyCheckboxEl, 'border-radius');
  }
}
